import React from 'react'
import type { ICollectionLink } from '../collections.interfaces'
import Icon from './icon.component'
import TextContainer from './text-container.component'

interface CollectionTopNavLinkProps {
  key: string
  link: ICollectionLink
  isActive: boolean
  onClick: (event: React.MouseEvent<HTMLDivElement>, link: ICollectionLink) => void
}

const CollectionTopNavLink: React.FC<CollectionTopNavLinkProps> = ({ link, isActive, onClick }) => {
    return (
        <div 
            key={link.handle}
            className={`collection-top-nav__tab_item ${isActive ? 'collection-top-nav__tab_item--active' : ''}`}
            onClick={(event: React.MouseEvent<HTMLDivElement>) => onClick(event, link)}>
            <a
            href={link.handle}
            className="collection-top-nav__link"
            >
            <Icon className={link.handle} alt={link.handle} />
            <TextContainer text={link.title} isActive={isActive}/>
            </a>
        </div>
    )
}

export default CollectionTopNavLink
